import DocumentItems from "./DocumentItems";

export default DocumentItems;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/index.js